import {SET_MESSAGE_ASSIGNMENTS, FETCH_ALL_ASSIGNMENTS, RECEIVED_ASSIGNMENT_RESULTS, FETCH_ASSIGNMENT_FAILED} from "./types";
import ElasticSearchStore from "./elastic-search-store";

export default class ManageAssignmentActions {

    static store = new ElasticSearchStore();
    static fetchAllAssignments(dispatch, owner, type = 'assignmentdev', options = {
        'match': {
            'originalOwner': owner
        }
    }, columns = [
        'id', 'type', 'keywords', 'ownerName', 'visibleTo', 'assignmentName', 'status', 'dueDate', 'createdAt'
    ], success, failure, alertText, alertStyle, showAlert) {
        ManageAssignmentActions.store.query(dispatch, type, options, columns, success, failure).then(results => {
            
            dispatch({
                type: RECEIVED_ASSIGNMENT_RESULTS,
                status: 200,
                data: JSON.parse(JSON.stringify(results.data)),
                alertText: alertText,
                alertStyle: alertStyle,
                showAlert: showAlert
            });
        }).catch(error => {
            console.error(error);
            dispatch({
                type: FETCH_ASSIGNMENT_FAILED,
                status: 400,
                data: error,
                alertText: alertText,
                alertStyle: alertStyle,
                showAlert: showAlert
            })
        })
    }

    static getAssignment(dispatch, type = 'assignmentdev', id = null, columns = [
        'id', 'type', 'keywords', 'ownerName', 'visibleTo', 'assignmentName', 'status', 'dueDate', 'createdAt'
    ], success, failure) {
        let data = {};
        if (columns && columns.length > 0) {
            data['_source'] = {
                'includes': columns
            }
        }
        if (columns && columns.length > 0) {
            data['_source'] = {
                'includes': columns
            }
        }
        ManageAssignmentActions.store.getRecord(dispatch, type, id, columns, success, failure);
    }

    static setMessage(dispatch, showAlert, alertText,alertStyle, callBack){
        dispatch({
            type:SET_MESSAGE_ASSIGNMENTS,
            showAlert:showAlert,
            alertText:alertText,
            alertStyle:alertStyle
        });
        callBack();
    }
}
